import { ReactNode } from "react";
import HorzontalTimeLine from "./HorzontalTimeLine";
import VerticalTimeLine from "./VerticalTimeLine";
import { ISatus } from "@/redux/store.types";

export interface ITimeLineData {
  id: number;
  renderer: ReactNode;
  status: ISatus;
}

type Props = {
  direction?: "horizontal" | "vertical";
  data?: any | any[];
  limit?: number;
};

export const TimeLine = ({
  direction = "horizontal",
  data,
  limit = 10,
}: Props) => {
  if (!data) return null;
  if (direction === "horizontal") {
    return <HorzontalTimeLine data={data} limit={limit} />;
  }
  return <VerticalTimeLine data={data} limit={limit} />;
};

export default TimeLine;
